// utils/decryptUserID.js
export const decryptUserID = (encryptedID) => {
    const decodedID = atob(encryptedID); // Simple Base64 decoding
    return decodedID;
  };
  